import * as c from '../constants/ApprovalRequestConstants'

const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: {},
  examWindowRefData: {},
  examDateRefData: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case `${c.FETCH_APPROVAL_REQUEST_EXAM_WINDOWS}_PENDING`:
      return { ...state, fetching: true, fetched: false, error: null }

    case `${c.FETCH_APPROVAL_REQUEST_EXAM_WINDOWS}_FULFILLED`: {
      const { data, examWindowRefData, examDateRefData, educationPeriodCd } = payload
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: {
          ...state.data,
          [educationPeriodCd]: {
            ...data,
          },
        },
        examWindowRefData: {
          ...state.examWindowRefData,
          [educationPeriodCd]: {
            ...examWindowRefData,
          },
        },
        examDateRefData: {
          ...state.examDateRefData,
          [educationPeriodCd]: [...examDateRefData],
        },
      }
    }

    case `${c.FETCH_APPROVAL_REQUEST_EXAM_WINDOWS}_REJECTED`:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
